/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.DataTable')
    .constant('DATA_TABLE_EVENTS', {
        SET_WIDTH: 'dataTable.setWidth'
        // TODO: Move `reload.dataTable` here and rename to `dataTable.reload`
    })
    .directive('accDataTable', ['PaginationService', 'SortingService', 'SearchService', function(PaginationService, SortingService, SearchService) {
    return {
        scope: true,
        compile: function($element) {
            $element.find('table')
                .attr('ng-class', "{'loading': table.loading, 'loaded': !table.loading}")
                .addClass('data-table')
                .after('<div class="overlay-disabled" ng-show="table.loading"></div>');
        },
        controller: ['$scope', '$element', '$attrs', '$document', '$injector', 'TableStateSavingService', '$timeout',
            function($scope, $element, $attrs, $document, $injector, TableStateSavingService, $timeout) {
            var
                id = $attrs['id'],
                state = TableStateSavingService.getState(id),
                pagination = PaginationService['new'](state['perPage'] || _getTable().perPage),
                sorting = SortingService['new'](state['sortingColumn'] || $attrs['defaultSortingColumn'], state['sortingDirection'] || $attrs['defaultSortingDirection']),
                header = $injector.has('headerService') && $injector.get('headerService'), // admin does not have, nor need headerService
                searchState = SearchService.searchState,
                loaded = false,
                model,
                activeRequest;

            $scope.table = _getTable();
            model = $scope.table.model;
            $scope.filters = $scope.filters || $scope.table.filters;
            $scope.columnInfo = state['columnInfo'] || {};
            loadColumns();

            // TODO move filters, sorting and pagination to $scope.table
            $scope.pagination = pagination;
            $scope.sorting = sorting;
                
            function _getTable() {
                return angular.extend($scope.table || {}, {
                    model: $scope.table && $scope.table.model || $injector.get($attrs['model']),
                    filters: $scope.table && $scope.table.filters || {},
                    pagination: pagination,
                    filteredEntries: [],
                    advancedFilters: null,
                    isEmpty: false,
                    concatEntries: true,
                    loading: false,
                    loadingMore: false
                });
            }

            $scope.searchMode = function() {
                return !!($scope.table.filters['name']);
            };

            if (searchState.rootSearchString) {
                $scope.table.filters.name = searchState.rootSearchString;
                searchState.rootSearchString = '';
                setSearchingStarted();
                _search();
            } else if(!$scope.table['loadOnlyOnSeach']) {
                query();
            }
            
            $scope.$watch('table.supportsSearch', function(supportsSearch) {
                searchState.enabled = !!supportsSearch;
            });

            $scope.$watch('columnInfo', function(){
                state['columnInfo'] = $scope.columnInfo;
                TableStateSavingService.setState(id, state);
            }, true);
            
            SearchService.search = function() {
                setSearchingStarted();
                _search();
            };
    
            SearchService.resetSearch = function() {
                _resetSearch();
            };

            $document.on('reload.dataTable', function(){    // TODO fix in users and devices and remove!!
                reload();
            });

            $scope.$on('reload.dataTable', function(){
                reload();
            });

            $scope.changePerPage = function(perPage) {
                if(perPage != pagination.getPerPage()) {
                    pagination.setPerPage(perPage);
                    state['perPage'] = perPage;
                    TableStateSavingService.setState(id, state);
                    query();
                }
            };

            $scope.changePage = function(page) {
                if(page != pagination.getPage()) {
                    pagination.setPage(page);
                    query();
                }
            };

            $scope.table.reload = $scope.applyFilters = function() {
                reload();
            };

            // @depricated user table.resetFilters
            $scope.resetFilters  = function() {
                $scope.filters = {};
                reload();
            };

            $scope.table.resetFilters = function() {
                $scope.table.filters = {};
                $scope.resetFilters();
            };

            $scope.setFilter = function(filter) {
                $scope.filters = {};
                $scope.filters[filter] = true;
                reload();
            };

            $scope.isActiveFilter = function(filter) {
                return $scope.filters[filter];
            };

            $scope.sortColumn = function(index, defaultSortingDirection) {
                sorting.setColumn(index, defaultSortingDirection);
                state['sortingColumn'] = sorting.getColumn();
                state['sortingDirection'] = sorting.getDirection();
                TableStateSavingService.setState(id, state);
                reload();
            };

            $scope.table.columnCount = function() {
                var columnCount = 0;
                angular.forEach($element.find('thead tr:first-child() th'), function(th){
                    var colspan = angular.element(th).attr('colspan');
                    if(colspan) {
                        columnCount += parseInt(colspan);
                    } else {
                        columnCount ++;
                    }
                });

                return columnCount;
            };

            function loadColumns() {
                $scope.columns = [];
                angular.forEach($element.find('th[data-column-name]'), function(column){
                    var $column = angular.element(column);
                    $scope.columns.push({
                        id: $column.data('columnName'),
                        name: function(){ return $column.text() }
                    });
                });
            }

            function reload() {
                if ($scope.table.hasInfiniteScroll) {
                    loaded = false;
                }
                pagination.setPage(pagination.firstPage());
                $scope.searchMode() ? _search() : query();
            }

            function query() {
                sendRequest('query');
            }
    
            $scope.loadMore = $scope.table.loadMore = function(){
                if (!$scope.searchMode() && !$scope.table.loadingMore && !loaded) {
                    pagination.setPage(pagination.getPage() + 1);
                    sendRequest('query');
                }
            };
            
            function _search() {
                if (!searchState.string) return;
                
                var preloadCount = $scope.table.searchPreloadCount;
                
                $scope.table.filters.name = searchState.string;
    
                pagination.setPage(1);
                sendRequest('search', {page: 1, per_page: preloadCount || 2048}).then(function() {
                    if (preloadCount && pagination.getTotal() > preloadCount) {
                        pagination.setPage(2); // we don't send this param but we need it to determine we're not on the first page
                        sendRequest('search', {offset: preloadCount, per_page: pagination.getTotal() - preloadCount}).then(function() {
                            setSearchingFinished();
                        });
                    } else {
                        setSearchingFinished();
                    }
                });
            }
            
            function sendRequest(method, paginationParams) {
                paginationParams = paginationParams || pagination.getQueryParams();
                
                cancelActiveRequest();
                setTableLoading();
                
                activeRequest = model[method](angular.extend({}, paginationParams, sorting.getQueryParams(), $scope.filters, $scope.table.filters),
                    function(data, getHeader) {
                        pagination.parseContentRangeHeader(getHeader);
                        
                        if (!$scope.table.concatEntries || pagination.isOnFirstPage()) {
                            $scope.table.entries = data;
                            $scope.table.isEmpty = data.length <= 0;
                        } else {
                            if (data.length > 0) {
                                $scope.table.entries = $scope.table.entries.concat(data);
                            } else {
                                loaded = true;
                            }
                        }
            
                        setTableLoaded();
                    }, handleError);
    
                return activeRequest.$promise;
            }
    
            function _resetSearch() {
                searchState.string = '';
    
                if ($scope.searchMode()) {
                    $scope.table.entries = [];
                    $scope.table.filters.name = null;
                    $scope.table.advancedFilters = null;
                    $scope.applyFilters();
                }
            }
            
            function cancelActiveRequest() {
                if (activeRequest && !activeRequest.$resolved) {
                    activeRequest.$cancelRequest();
                    activeRequest = null;
                }
            }
            
            function setSearchingStarted() {
                $scope.table.searching = searchState.searching = true;
            }
            
            function setSearchingFinished() {
                $timeout(function() { // making sure this is executed in the next digest cycle so the number is correct
                    searchState.numFound = $scope.table.filteredEntries.length;
                    $scope.table.isEmpty = $scope.table.filteredEntries.length < 1;
                    $scope.table.searching = searchState.searching = false;
                });
            }

            function setTableLoading() {
                if (pagination.isOnFirstPage()) {
                    $scope.table.loading = true;
                    if (header) { header.loading = true; }
                    SearchService.setSearchState($scope.searchMode());
                } else {
                    $scope.table.loadingMore = true;
                }
            }

            function setTableLoaded() {
                if (pagination.isOnFirstPage()) {
                    $timeout(function () {
                        $scope.table.loading = false;
                        if (header) { header.loading = false; }
        
                        if ($scope.searchMode()) {
                            SearchService.setSearchState(true, $scope.currentNode);
                        }
                    }, 100);
                } else {
                    $scope.table.loadingMore = false;
                }
            }
            
            function handleError(response) {
                if (response.status !== -1) { // cancelled requests have status -1
                    setTableLoaded();
                }
            }
        }]

    }
}]);
